import { INotificationsStore } from '../store';

import { IStore } from '../../index';
import { IErrorsStore } from '../../errors/store';

export const close = (
  state: IStore
): { errors: IErrorsStore; notifications: INotificationsStore } => {
  return {
    errors: {},
    notifications: {
      ...state.notifications,
      open: false
    }
  };
};
